<template>
  <el-dialog
    v-dialogDrag
    :visible.sync="uploadDialog"
    :before-close="handleClose"
    class="title"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="重新轻量化提示"
  >
    <div class="integrationRecordTable">
      <div class="content">
        该图标为执行轻量化操作，非打开模型控件，点击后将进行重新轻量化，如果通过插件上传的模型会影响当前模型正常使用，确认要转换吗？如果是想打开模型浏览，请直接点击该模型文件。
      </div>
      <div class="content">
        <el-checkbox v-model="lightweightReminder">不再显示</el-checkbox>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" @click="lightweightReminderBtn"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>
  
  <script>
export default {
  data() {
    return {
      uploadDialog: false,
      lightweightReminder:
        JSON.parse(localStorage.getItem("lightweightReminder")) || false,
    };
  },

  methods: {
    openDialog() {
      this.uploadDialog = true;
    },
    handleClose() {
      this.uploadDialog = false;
    },
    lightweightReminderBtn() {
      this.uploadDialog = false;
      localStorage.setItem("lightweightReminder", this.lightweightReminder);
      this.$emit("lightweight");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 5px 20px !important;
}

.integrationRecordTable {
  width: 100%;
  height: 145px;
  .content {
    line-height: 34px;
    color: #323232;
    font-size: 14px;
    // padding-left: 28px;
  }
  .contentPad {
    padding-left: 151px;
  }
}
</style>
  